import React from 'react';
import { CaseTypeType } from '../../../Enums/CaseTypeType.enum';
import { CaseTypeTreeItem } from '../../../Hooks/useCaseTypeTree';
import styles from './CaseTypeListItem.module.scss';
import { joinClasses } from '../../../../../Utils/className.util';
import { Theme } from '../../../../../Enums/Theme.enum';
import Text from '../../../../../Components/Base/Text/Text';
import LinkButton from '../../../../../Components/Button/LinkButton';

interface Props {
	item: CaseTypeTreeItem;
	onEdit: (item: CaseTypeTreeItem) => void;
}

const CaseTypeListItem: React.FC<Props> = ({ item, onEdit }) => {
	const hasChildren = (item.children?.length || 0) > 0;

	let component;

	switch (item.caseType.type) {
		case CaseTypeType.FOLDER:
			component = (
				<div
					className={joinClasses([
						styles.item,
						!item.parentId ? styles.mainFolder : '',
					])}>
					<div className={styles.content}>
						<div>
							<img src='/dist/icons/folder-open-solid.svg' />{' '}
						</div>
						<div className={styles.label}>
							<div>{item.caseType.label}</div>
							{!hasChildren && (
								<Text
									tx='component.caseTypeListItem.folderNoChildrenMessage'
									className={styles.subtitle}
								/>
							)}
						</div>
					</div>
					<div className={styles.control}>
						<LinkButton
							title='base.shared.edit'
							theme={Theme.BLUE}
							onClick={() => onEdit(item)}
							firstUpper
						/>
					</div>
				</div>
			);
			break;
		case CaseTypeType.CASE_TYPE:
			component = (
				<div className={joinClasses([styles.item, styles.caseType])}>
					<div className={styles.content}>{item.caseType.label}</div>
					<div className={styles.control}>
						<LinkButton
							title='base.shared.edit'
							theme={Theme.BLUE}
							onClick={() => onEdit(item)}
							firstUpper
						/>
					</div>
				</div>
			);
			break;
	}

	return (
		<div className={styles.wrapper}>
			{component}{' '}
			{hasChildren && (
				<div className={styles.childrenWrapper}>
					{item.children?.map(child => (
						<CaseTypeListItem item={child} onEdit={onEdit} key={child.id} />
					))}
				</div>
			)}
		</div>
	);
};

export default CaseTypeListItem;
